import { render, staticRenderFns } from "./create-transaction.vue?vue&type=template&id=529e408f&scoped=true"
import script from "./create-transaction.vue?vue&type=script&lang=js"
export * from "./create-transaction.vue?vue&type=script&lang=js"
import style0 from "./create-transaction.vue?vue&type=style&index=0&id=529e408f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e408f",
  null
  
)

export default component.exports